import React from "react";
import Styles from './styles.module.scss'

import Seo from "../../components/_UI/seo";
import {useTranslation} from "react-i18next";
import VerifyEmailMain from "../../components/verifyEmailMain";
import AuthRedirect from "../../components/authRedirect";



const VerifyEmailPage = () => {
    const { t } = useTranslation();

    return (
        <section className={`${Styles.container}`}>
            <Seo title={t('Подтвердите, что это вы')}/>
            <AuthRedirect/>
            <VerifyEmailMain/>
        </section>
    );
};

export default VerifyEmailPage;